import { ExportCampaignPosts, ExportCampaignTotalTimeseries } from '@/entities/campaign';
import { trackEvent } from '@/shared/track';
import { exportToCSV } from '@/shared/utils/export-to-csv';
import {
  buildCampaignExportFileName,
  type CampaignExportRequest,
} from '../../../helpers/campaign-export';

export const exportCampaign = async (
  campaignId: string,
  campaignName: string,
  request: CampaignExportRequest,
): Promise<void> => {
  let csvString: string;
  if (request.type === 'total') {
    if (!request.startDate || !request.endDate) {
      throw new Error('Choose an export date range and try again.');
    }
    csvString = await ExportCampaignTotalTimeseries(campaignId, {
      start_date: request.startDate,
      end_date: request.endDate,
    });
  } else if (request.type === 'post') {
    csvString = await ExportCampaignPosts(campaignId);
  } else {
    throw new Error('Invalid export request type');
  }

  trackEvent('Campaign', 'export_succeeded', {
    exportFormat: request.format,
    exportType: request.type,
  });

  const fileName = buildCampaignExportFileName({
    campaignName: campaignName,
    request,
  });
  exportToCSV(csvString, fileName);
};
